import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, Heading } from '@innovationnorway/cl-react';

interface AskCustomerMessageStepProps {
  dialogOpen: boolean;
  onWriteMessage: () => void;
  onSkip: () => void;
}

const AskCustomerMessageStep = ({ dialogOpen, onWriteMessage, onSkip }: AskCustomerMessageStepProps) => {
  const { t: tCommon } = useTranslation();
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  return (
    <Dialog open={dialogOpen} onClose={onSkip} aria-label={tOneWayIn('refer.dialog.ariaLabel')}>
      <Heading level={2} className="font-size--ds-6 font-weight--500">
        {tOneWayIn('refer.dialog.customerEmailPrompt.title')}
      </Heading>
      <p>{tOneWayIn('refer.dialog.customerEmailPrompt.description')}</p>

      <div className="display--flex gap--ds-5">
        <Button onClick={onWriteMessage}>{tCommon('yes')}</Button>
        <Button variant="secondary" onClick={onSkip}>
          {tCommon('no')}
        </Button>
      </div>
    </Dialog>
  );
};

export default AskCustomerMessageStep;
